"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Database, Lock, Cloud } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DetailsduService() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative bg-background py-20 px-6 lg:px-12 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-dark/20 via-transparent to-primary-dark/10 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {}
        <div ref={leftRef} className={`glass-effect p-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-foreground mb-6">Détails du Service</h2>
          <div className="space-y-4">
            <p className="text-muted-foreground">
              Nos services couvrent l'ensemble du spectre technologique : Cloud, Data, IA, Cybersécurité et M&A. Nous vous accompagnons dans la maîtrise de la complexité pour créer une valeur durable et tangible.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-3 gap-6">
          {}
          <div ref={card1Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${card1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: card1Visible ? "100ms" : "0ms"
        }}>
            <Card className="hover-lift">
              <CardHeader>
                <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 mb-4">
                  <Database className="w-8 h-8 text-primary" />
                </div>
                <CardTitle className="text-foreground">Plateformes Data</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">
                  Industrialisez votre infrastructure de données avec des plateformes modernes conçues pour l'évolutivité et la performance.
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={card2Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${card2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: card2Visible ? "200ms" : "0ms"
        }}>
            <Card className="hover-lift">
              <CardHeader>
                <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 mb-4">
                  <Lock className="w-8 h-8 text-primary" />
                </div>
                <CardTitle className="text-foreground">Cybersécurité</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">
                  Assurez la confiance numérique grâce aux principes de sécurité dès la conception, à la conformité et aux stratégies de résilience.
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={card3Ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${card3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: card3Visible ? "300ms" : "0ms"
        }}>
            <Card className="hover-lift">
              <CardHeader>
                <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 mb-4">
                  <Cloud className="w-8 h-8 text-primary" />
                </div>
                <CardTitle className="text-foreground">Stratégie Cloud</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">
                  Maîtrisez les architectures hybrides et multi-cloud avec des modèles de gouvernance adaptés à votre entreprise.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}